import React, { Component } from 'react';
import jquery from 'jquery';
import { Table, Tabs, message, Modal } from 'antd';
import EditableCell from '../../../common/tableCell/TableCell';
import TableC from '../../../basicElement/TableC';
import AjaxRequest from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import moment from 'moment';
const { TabPane } = Tabs;

class CrfTable extends React.Component {
	state = {
		dataSource: [],
		columns: [],
		count: 0,
		scrollX: false,
		loading: false,
		tableColumns: [],
		requiredMap: new Map(),
		moduleDefineCode: '',
		moduleDefineId: null,
		hasChild: 0,
	
	}

	getSaveParam = (rowDataOriginal) => {
		const rowData = JSON.parse(JSON.stringify(rowDataOriginal));
		const paramsObj = {
			newParams: '',
			postObj: {}
		};
		let indicatorCount = -1;
		const indicatorRowCount = {};
		const rowIndexObj = {};
		let newParams = ``;
		newParams += `?`;
		const { moduleDefineCode: userModuleDefineCode } = this.state;
		for (let key in rowData) {
			if (typeof rowData[key] === "object" && rowData[key] !== null) {
				if (key === (rowData[key].moduleDefineCode + '_' + rowData[key].rowNum) || userModuleDefineCode === key) {
					const { moduleDefineCode } = rowData[key];
					const rowCount = indicatorRowCount[moduleDefineCode];
					let prevModuleDefineCode;
					if (rowData[moduleDefineCode]) {
						if (Array.isArray(rowData[moduleDefineCode])) {
							prevModuleDefineCode = rowData[moduleDefineCode];
						} else {
							prevModuleDefineCode = [rowData[moduleDefineCode]];
						}
					} else {
						prevModuleDefineCode = [];
					}
					const prevData = prevModuleDefineCode.find(i => i.rowNum == rowData[key].rowNum) || null;
					if (!prevData && rowData[key].value) {
						rowData[key]["operationType"] = 'INSERT';
					} else if (prevData && prevData.value && !rowData[key].value) {
						rowData[key]["operationType"] = 'DELETE';
					} else if (prevData && prevData.value && rowData[key].value) {
						if (prevData.value != rowData[key].value || prevData.comment != rowData[key].comment) {
							rowData[key]["operationType"] = 'UPDATE';
						}
					}
					if (userModuleDefineCode === key && prevData && !rowData[userModuleDefineCode + '_' + prevData.rowNum].value && prevData.value) {
						rowData[key]["operationType"] = 'INSERT';
					}
					if (rowData[key].operationType) {
						if (rowCount >= 0) {
							indicatorRowCount[rowData[key].moduleDefineCode] = indicatorRowCount[rowData[key].moduleDefineCode] + 1;
						} else {
							indicatorRowCount[rowData[key].moduleDefineCode] = 0;
							indicatorCount++;
							rowIndexObj[rowData[key].moduleDefineCode] = indicatorCount;
						}
						for (const keySec in rowData[key]) {
							if (keySec == "rowNum" && rowData[key]["realRowNum"]) {
								paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicators[${indicatorRowCount[rowData[key].moduleDefineCode]}].${keySec}`] = rowData[key]["realRowNum"];
							} else {
								paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicators[${indicatorRowCount[rowData[key].moduleDefineCode]}].${keySec}`] = rowData[key][keySec] ? rowData[key][keySec] : '';
							}
						}
						paramsObj.postObj[`rowValues[${rowIndexObj[rowData[key].moduleDefineCode]}].indicatorCode`] = rowData[key].moduleDefineCode;
					}
				}
			} else {
				newParams += '&' + key + '=' + rowData[key];
			}
		}
		paramsObj.newParams = newParams;
		return paramsObj;
	}

	verify = (record) => {
		const { typeName } = this.props;
		const { requiredMap, isFilterProcess } = this.state;
		for (let [key, value] of requiredMap) {
			if (!record[key]) {
				if (requiredMap.get(key) == "筛选编号") {
					if (typeName == 'Type_Visit') {
						Modal.error({ title: `请选择您录入的筛选编号` });
					} else {
						Modal.error({ title: `请输入您录入的筛选编号` });
					}
					return;
				} else if (requiredMap.get(key) == "SAE结束时间" || requiredMap.get(key) == "与试验药物是否相关" || requiredMap.get(key) == "SAE结局") {
				} else {
					Modal.error({ title: `请输入${requiredMap.get(key)}` });
					return;
				}
			} else if (record[key]) {
				if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
					if (record[key].editable !== 0) {
						if (requiredMap.get(key) == "患者状态") {
							if (record[key]['value'] == "" || record[key]['value'] == undefined) {
								Modal.error({ title: `请选择患者状态` });
								return;
							}
						} else {
							if (record[key]['value'] == "" || record[key]['value'] == undefined) {
								if (typeName == 'Type_Visit' && requiredMap.get(key) == "筛选编号") {
									Modal.error({ title: `请选择筛选编号`});
									return;
								} else {
									Modal.error({ title: `请输入${requiredMap.get(key)}` });
									return;
								}
							}
						}
					}
				} else {
					if (requiredMap.get(key) == "SAE跟进情况" && record[key]['value'] == "结束") {
						for (let [key, value] of requiredMap) {
							if (record[key] == undefined || record[key] == "") {
								if (requiredMap.get(key) == "SAE结束时间" || requiredMap.get(key) == "与试验药物是否相关" || requiredMap.get(key) == "SAE结局") {
									Modal.error({ title: `请输入${requiredMap.get(key)}` });
									return;
								}
							} else if (record[key]) {
								if (record[key]['value'] == "" || record[key]['value'] == undefined) {
									Modal.error({ title: `请输入${requiredMap.get(key)}` });
									return;
								}
							}
						}
					} else if (requiredMap.get(key) == "SAE结束时间" || requiredMap.get(key) == "与试验药物是否相关" || requiredMap.get(key) == "SAE结局") {
					} else if (record[key]['value'] == "" || record[key]['value'] == undefined) {
						Modal.error({ title: `请输入${requiredMap.get(key)}` });
						return;
					}
				}
			}
		}
		if (!(record.key).endsWith('new5efk') && typeName == 'Type_Filter') {
			record ? this.save(record) : this.handleAddRecord();
		} else {
			this.save(record);
		}
	}

	save = (record, flag) => {
		const { currentGroup: { visitGroupingId }, typeName } = this.props;
		const { patientStatus } = sessionStorage;
		const parsePatientStatus = patientStatus ? JSON.parse(patientStatus) : {};
		const { quitTime, quitComment } = parsePatientStatus;

		const paramsObj = this.getSaveParam(record);
		this.setState({ loading: true });
		const options = {
			url: `${API_URL.execute.save}${paramsObj.newParams}`,
			data: {
				...paramsObj.postObj,
				typeName,
				visitGroupingId,
				isCheck: flag !== '' ? 1 : flag,
				quitTime,
				quitComment,
				isPreview:1,
			},
			method: 'post',
			dataType: 'json',
			doneResult: (data => {
				if (!data.confirmError) {
					this.setState({
						loading: false,
					}, () => {
						const { needTransfer = false, otherVisitGroupingId } = this.state;
						if (needTransfer) {
							this.transferData({ visitGroupingId: otherVisitGroupingId, patientId: (data.patientUserId || record.patientUserId) });
						} else {
							//this.props.loadRefData();
							this.props.loadData();
						}
					});
					message.success('保存成功');
					sessionStorage.removeItem('patientStatus');
				} else {
					Modal.confirm({
						iconType: 'exclamation-circle',
						title: <div style={{ marginLeft: 42 }}>该患者（访视）已被引用在工时记录中，删除此记录将同时影响对应工时的患者（访视）备注，是否确认删除?</div>,
						onOk: () => {
							this.save(record, '');
						},
					});
				}
			}),
			errorResult: () => {
				this.setState({ loading: false });
			},
			failResult: () => {
				this.setState({ loading: false });
			}
		};
		AjaxRequest.sendRequest(options);
	}

	transferData = (params) => {
		const { visitGroupingId, patientId } = params;
		this.setState({ loading: true });
		const options = {
			url: `${API_URL.execute.changePatientVisitGroupingId}`,
			data: {
				patientId,
				visitGroupingId,
			},
			dataType: 'json',
			doneResult: (res => {
				message.success(res.success);
                this.setState({
                    loading: false,
                    needTransfer: false,
                }, () => {
					this.props.loadRefData();
                    this.props.changeTabs(visitGroupingId);
                });
			}),
			errorResult: () => {
				this.setState({ loading: false });
			},
		};
		AjaxRequest.sendRequest(options);
	}

	getVisitDate = (referencedActualDate, referencedActualCode, rowIndex, criteriaDefineId, tableColumn, record) => {
		const { prevReferCodes = [] } = this.state;
		let params = {
			referencedActualCode
		};
		params.referencedActualDate = referencedActualDate == '' ? '' : referencedActualDate;
		const { rowNums = [], moduleDefineCode } = tableColumn;
		const { currentGroup: { visitGroupingId } } = this.props;
		rowNums && rowNums.map((key, index) => {
			let value = "";
			const dataIndex = moduleDefineCode + "_" + key;
			if (referencedActualCode == dataIndex) {
				value = referencedActualDate;
			} else if (record[dataIndex] && record[dataIndex].value) {
				value = record[dataIndex].value;
			}
			params[`keyValues[${index}].key`] = key;
			params[`keyValues[${index}].value`] = value;
		})
		if (visitGroupingId != '') {
			params.visitGroupingId = visitGroupingId;
			params.patientId = record.patientUserId;
		}
		prevReferCodes.push(referencedActualCode);
		this.setState({ prevReferCodes });
		const options = {
			url: API_URL.execute.getPlanVisitDate,
			data: { ...params },
			dataType: 'json',
			doneResult: (data => {
				const list = data.datas;
				if (list.length > 0) {
					list.map((value, index) => {
						const newTableColumn = {
							...tableColumn,
							moduleDefineCode: value[2],
							rowNum: value[3],
						}
						if (value[1]) {
							const flag = prevReferCodes.some(item => value[0] == item);
							if (!flag) {
								this.onCellChange(rowIndex, value[0], criteriaDefineId, true, record, newTableColumn)(value[1], 'value');
							} else {
								//this.onCellChange(rowIndex, value[0], criteriaDefineId, undefined, record, newTableColumn)(value[1], 'value');
							}
						} else {
							this.onCellChange(rowIndex, value[0], criteriaDefineId, undefined, undefined, newTableColumn)("", 'value');
						}
					})
				} else {
					this.setState({ prevReferCodes: [] });
				}
			}),
		};
		AjaxRequest.sendRequest(options);
	}

	convertColumns = (tableColumns) => {
		const columns = [];
		const { dataSource,isFilterProcess } = this.state;
		const { typeName, visitGroup, currentGroup } = this.props;
		const { visitGroupingId } = currentGroup;
		const dataEmpty = dataSource.length === 0 ? true : false;
		const requiredMap = new Map();
		const { curRole } = sessionStorage;
		const isPA = curRole == 'PA';
        const isPM = curRole == 'PM';
        const isBO = curRole == 'BO';
        const isBD = curRole == 'BD';
        const isVP = curRole == 'VP';
        const isBDO = curRole == 'BDO';
		const isFIN = curRole == 'FIN';
		const isCTA = curRole == 'CTA';
        const isCRC = curRole == 'CRC';
		const isCRCC = curRole == 'CRCC';
		const isCRCM = curRole == 'CRCM';
		const canEdit = isPA || isPM || isCRC || ((isBO || isBD || isVP || isBDO || isFIN || isCTA || isCRCC || isCRCM) && (typeName == 'Type_Filter' || typeName == 'Type_Pre_Filter'));
		
		const newTableColums = [];
		tableColumns.forEach(column => {
			const { rowNum, moduleDefineCode, moduleDefineName, moduleDefineIsRequired } = column;
			newTableColums.push(column);
			if (moduleDefineName !== '操作' || moduleDefineName !== '录入者') {
				if (moduleDefineIsRequired == "1") {
					requiredMap.set(moduleDefineCode + "_" + rowNum, moduleDefineName);
				} else if (moduleDefineIsRequired == "0" && (moduleDefineName == 'SAE结束时间' || moduleDefineName == '与试验药物是否相关' || moduleDefineName == 'SAE结局')) {
					requiredMap.set(moduleDefineCode + "_" + rowNum, moduleDefineName);
				}
			}
		});

		const isNeedWidth = newTableColums.length > 8;
		let scrollX = isNeedWidth ? (canEdit ? (newTableColums.length * 150 - 180) : ((newTableColums.length - 2) * 150)) : 955;
		newTableColums.map((tableColumn, columnIndex) => {
			let title = tableColumn.moduleDefineName || '',
				type = tableColumn.criteriaDataType,
				webType = tableColumn.projectDefineWebType,
				dataIndex = tableColumn.moduleDefineCode == "op" ? tableColumn.moduleDefineCode : tableColumn.moduleDefineCode + "_" + tableColumn.rowNum,
				criteriaDefineId = tableColumn.criteriaDefineId,
				canAddComment = tableColumn.canAddComment,
				column = {
					visitTypeName: tableColumn.visitTypeName,
					visitTypeNameShow: tableColumn.visitTypeNameShow,
					// width:150,
				},
				config = {
					isEdit: true,
					comment: {
						iscomment: false,
						//value: comment,
					},
					colorClass: "normal",
					type: {
						type: type,
						webType: webType,
						moduleDefineConstraintValue: tableColumn.moduleDefineConstraintValue,
						formatValue: tableColumn.formatValue
					},
					...tableColumn
				};
			// 预览时不需要检索
			if (title === '筛选编号' && typeName === 'Type_Filter') {
				config.type.type = 'TEXT';
				config.type.webType = 'INPUT';
			}
			if (isNeedWidth) {
				column.width = 150;
				if (title == '操作') {
					scrollX -= 90;
				}
			} else {
				column.width = (canEdit ? (955 - 120) : 955) / newTableColums.length;
			}
			if (tableColumn.fixed == "left" && isNeedWidth) {
				if (typeName == 'Type_Visit' || typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter') {
					column.fixed = 'left';
				}
			}
			if (webType) {
				column.dataIndex = dataIndex;
			}
			column.type = type;
			column.webType = webType;
			if (tableColumn.canAddComment == 1) {
				config.comment.iscomment = true;
			}
			if (title == '筛选编号') {
				column.title=<span>筛选编号</span>
			} else {
				column.title = (<div style={{ display: "inline-block" }}>{title.split("\r\n").map((i, index) => {
					return <p>{i}</p>;
				})}</div>);
			}
			if (dataIndex !== "op" && title != '录入者' && canAddComment != 1) {
				if (columnIndex == 1) {//当第一列且有加号的时候特殊处理
					column.render = (text, record, index) => {
						config.isEdit = true;//放弃使用config中的isEdit判断是否可编辑，因为config外部引用问题有bug。
						let isEdit = true;
						if (record) {
							if (record.editable == 0) {
								isEdit = false;
							}
						}
						if (text) {
							if (text.editable == 0) {
								isEdit = false;
							}
						}
						if (typeName == 'Type_Visit') {
							if (isFilterProcess == 1) {
								if (title == '患者编号' || title == '随机(入组)时间'){
									isEdit = false;
								}
							} else {
								if (title == '筛选编号' || title == '筛选时间'){
									isEdit = false;
								}
							}
							
						} else if (typeName == 'Type_Filter' && title == '是否第一个受试者入组') {
							isEdit = false;
						}
						let cellDom = <div style={(record.children && record.children.length > 0) ? { paddingLeft: '20px' } : {}}>
							<EditableCell
								cellValue={text}
								parent="crfPeriod"
								onChange={this.onCellChange(index, dataIndex, criteriaDefineId, false, record, tableColumn)}
								onPatientCodeChange={this.onPatientCodeChange(index, dataIndex, criteriaDefineId, record)}
								preView={true}
								config={config}
								isEdit={isEdit}
								typeName={typeName}
								record={record}
								index={index}
							/>
						</div>
						return ( !dataEmpty ? cellDom : null )
					}
				} else {
					column.render = (text, record, index) => {
						config.isEdit = true;
						let isEdit = true;
						if (record) {
							if (record.editable == 0) {
								isEdit = false;
							}
						}
						if (text) {
							if (text.editable == 0) {
								isEdit = false;
							}
						}
						if (typeName == 'Type_Visit') {
							if (isFilterProcess == 1) {
								if (title == '患者编号' || title == '随机(入组)时间'){
									isEdit = false;
								}
							} else {
								if (title == '筛选编号' || title == '筛选时间'){
									isEdit = false;
								} else {
									isEdit = true;
								}
							}
							
						}  else if (typeName == 'Type_Filter' && title == '是否第一个受试者入组') {
							isEdit = false;
						}
						let special = false;
						if (typeName == 'Type_Visit') {
							if (title == '筛选时间' || title == '随机(入组)时间') {
								special = true;
							}
						}
						return (
							!dataEmpty &&
							<EditableCell
								cellValue={text}
								parent="crfPeriod"
								onChange={this.onCellChange(index, dataIndex, criteriaDefineId, special, record, tableColumn)}
								onPatientCodeChange={this.onPatientCodeChange(index, dataIndex, criteriaDefineId, record)}
								preView={true}
								config={config}
								isEdit={isEdit}
								visitGroup={visitGroup}
								currentGroup={currentGroup}
								typeName={typeName}
								record={record}
								index={index}
							/>
						)
					}
				}

				columns.push(column);
			} else if (canAddComment == 1) {
				column.render = (text, record, index) => {
					let isEdit = true;
					config.isEdit = true;
					if (record) {
						if (record.editable === 0) {
							isEdit = false;
						}
					}
					if (text) {
						if (text.editable === 0) {
							isEdit = false;
						}
					}
					if (typeName == 'Type_Visit' && (title == '患者编号' || title == '随机(入组)时间')) {
						isEdit = false;
					} else if (typeName == 'Type_Filter' && title == '是否第一个受试者入组') {
						isEdit = false;
					}
					return (
						!dataEmpty &&
						<EditableCell
							cellValue={text}
							parent="crfPeriod"
							onChange={this.onCellChange(index, dataIndex, criteriaDefineId, true, record, tableColumn)}
							onPatientCodeChange={this.onPatientCodeChange(index, dataIndex, criteriaDefineId, record)}
							preView={true}
							config={config}
							isEdit={isEdit}
							typeName={typeName}
							record={record}
							index={index}
						/>
					)
				}
				columns.push(column);
			}
		});
		this.setState({ requiredMap });

		if (canEdit) {
			let fixed = "right";
			if (this.state.hasChild === 1) {
				fixed = false;
			}
			const opColumn = {
				title: '操作',
				dataIndex: 'operate',
				key: 'operate',
				fixed: isNeedWidth ? fixed : null,
				width: 60,
				render: (text, record, index) => {
					if (record.children && record.children.length > 0) {
						return (<div className="editable-cell" style={{ minHeight: 38 }}> - </div>)
					} else {
						return (
							!dataEmpty &&
							<div className="editable-cell" style={{ minHeight: 38 }}>
								{
									(isPM || isPA || isCTA || isBO) &&
									(
										record.isSave ?
											<a onClick={() => this.verify(record)}>保存</a>
										:
											<a disabled={true}>保存</a>
									)
								}
							</div>
						);
					}
				},
			};
			columns.push(opColumn);
		}

		const params = {};
		const parentColumn = [];
		columns.map((column) => {
			if (column.visitTypeNameShow) {
				if (Object.keys(params).length > 0) {
					for (let key in params) {
						if (key != column.visitTypeNameShow) {
							params[column.visitTypeNameShow] = column.visitTypeNameShow.split(',');
						}
					}
				} else {
					params[column.visitTypeNameShow] = column.visitTypeNameShow.split(',');
				}
			}
		});

		if (Object.keys(params).length > 0) {
			for (let key in params) {
				let isExist = false;
				const typeColumn = {};
				params[key].map((item, index) => {
					if (parentColumn.length > 0) {
						parentColumn.map((parItem, parIndex) => {
							if (parItem.title == params[key][0]) {
								isExist = true;
							}
						});
						
						if (isExist) {
							parentColumn.map((parItem, parIndex) => {
								if (parItem.title == params[key][0]) {
									if (index == 0) {
										columns.map((column) => {
											if (column.visitTypeNameShow == `${params[key][0]}`) {
												parItem.children.push(column);
											}
										});
									} else if (index == 1) {
										let flag = false;
	
										parItem.children.map((innerItem, innerIndex) => {
											if (innerItem.title == params[key][1]) {
												flag = true;
												columns.map((column) => {
													if (column.visitTypeNameShow == `${params[key][0]},${params[key][1]}`) {
														innerItem.children.push(column);
													}
												});
											}
										});
	
										if (!flag) {
											const obj = {};
											obj.title = item;
											obj.children = [];
	
											columns.map((column) => {
												if (column.visitTypeNameShow == `${params[key][0]},${params[key][1]}`) {
													obj.children.push(column);
												}
											});
											parItem.children.push(obj);
										}
									} else if (index == 2) {
										const obj = {};
										obj.title = item;
										obj.children = [];
										columns.map((column) => {
											if (column.visitTypeNameShow == `${params[key][0]},${params[key][1]},${params[key][2]}`) {
												obj.children.push(column);
											}
										});
										parItem.children.map((innerItem, innerIndex) => {
											if (innerItem.title == params[key][1]) {
												if(innerItem.title.includes('#')) innerItem.title = '';
												innerItem.children.push(obj);
											}
										});
									}
								}
							});
						} else {
							if (index == 0) {
								typeColumn.title = item;
								typeColumn.children = [];
								columns.map((column) => {
									if (column.visitTypeNameShow == `${params[key][0]}`) {
										typeColumn.children.push(column);
									}
								});
							} else if (index == 1) {
								const obj = {}
								obj.title = item;
								obj.children = [];
		
								columns.map((column) => {
									if (column.visitTypeNameShow == `${params[key][0]},${params[key][1]}`) {
										obj.children.push(column);
									}
								});
								typeColumn.children.push(obj);
							} else if (index == 2) {
								const obj = {}
								obj.title = item;
								obj.children = [];
		
								columns.map((column) => {
									if (column.visitTypeNameShow == `${params[key][0]},${params[key][1]},${params[key][2]}`) {
										obj.children.push(column);
									}
								});
								typeColumn.children.map((innerItem, innerIndex) => {
									if (innerItem.title == params[key][1]) {
										if(innerItem.title.includes('#')) innerItem.title = '';
										innerItem.children.push(obj);
									}
								})
							}
						}
					} else {
						if (index == 0) {
							typeColumn.title = item;
							typeColumn.children = [];
							columns.map((column) => {
								if (column.visitTypeNameShow == `${params[key][0]}`) {
									typeColumn.children.push(column);
								}
							});
						} else if (index == 1) {
							const obj = {}
							obj.title = item;
							obj.children = [];
	
							columns.map((column) => {
								if (column.visitTypeNameShow == `${params[key][0]},${params[key][1]}`) {
									obj.children.push(column);
								}
							});
							typeColumn.children.push(obj);
						} else if (index == 2) {
							const obj = {}
							obj.title = item;
							obj.children = [];
	
							columns.map((column) => {
								if (column.visitTypeNameShow == `${params[key][0]},${params[key][1]},${params[key][2]}`) {
									obj.children.push(column);
								}
							});
							typeColumn.children.map((innerItem, innerIndex) => {
								if (innerItem.title == params[key][1]) {
									if(innerItem.title.includes('#')) innerItem.title = '';
									innerItem.children.push(obj);
								}
							})
						}
					}
				});

				!isExist && parentColumn.push(typeColumn);
			}
		}

		columns.map((item, index) => {
			if (item.visitTypeNameShow) {
				if (parentColumn.length > 0) {
					parentColumn.map((innerItem, innerIndex) => {
						if (item.visitTypeNameShow.split(',')[0] == innerItem.title) {
							columns[index] = parentColumn[innerIndex];
							parentColumn.splice(innerIndex, 1);
						}
					});
				} else {
					if (item.visitTypeNameShow) {
						delete columns[index];
					}
				}
			}
		});

		columns.map((item, index) => { 
			if (item.visitTypeNameShow) {
				delete columns[index];
			}
		});
		this.setState({ scrollX });
		return { columns };
	}

	convertDataSource = (dataSource, tableColumns = []) => {
		let key = 0;
		const { criteriaDefineId } = this.state;
		const { controllers, typeName } = this.props;
		const data = dataSource.map(rowData => {
			const rowDataKey = Object.entries(rowData);
			let rowNum = 1;
			rowDataKey.map(rowKeyValue => {
				if (Array.isArray(rowKeyValue[1])) {
					const fieldArray = rowKeyValue[1];
					fieldArray.map((field => {
						rowNum = field.rowNum;
						const newKeyName = rowKeyValue[0] + "_" + rowNum;
						rowData[newKeyName] = { ...field };
						// 填写控制
						if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
							const controll = controllers.find(controll => controll.controlled == rowKeyValue[0]);
							const controller = controll ? controll.controller : '';
							const controllValue = controll ? controll.value : '';
							const array = rowDataKey.find(rowData => rowData[0] == controller);
							const result = array ? array[1][rowNum - 1] ? array[1][rowNum - 1].value : '' : '';
							if (controll) {
								if (controll.controllerName == '随机(入组)时间' && (controll.controlledName == '患者编号' || controll.controlledName == '患者状态')) {
									rowData[newKeyName]['editable'] = (!!result && array[1][rowNum - 1].editable != 0) ? 1 : 0; 
								} else {
									rowData[newKeyName]['editable'] = ((result === controllValue) && array[1][rowNum - 1].editable != 0) ? 1 : 0;
								}
							}
						}
					}));
				}
			});
			// 填写控制
			if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
				// 筛选出没数据的指标
				const columns = tableColumns.filter(item => !rowDataKey.find(rowKeyValue => rowKeyValue[0] == item.moduleDefineCode && rowKeyValue[1].length));
				columns.forEach(item => {
					const controll = controllers.find(controll => controll.controlled == item.moduleDefineCode);
					const controller = controll ? controll.controller : '';
					const controllValue = controll ? controll.value : '';
					const array = rowDataKey.find(rowData => rowData[0] == controller);
					const result = array ? array[1][rowNum - 1] ? array[1][rowNum - 1].value : '' : '';
					let editable;
					if (controll) {
						if (controll.controllerName == '随机(入组)时间' && (controll.controlledName == '患者编号' || controll.controlledName == '患者状态')) {
							editable = (!!result && array[1][rowNum - 1].editable != 0) ? 1 : 0;
						} else {
							editable = ((result === controllValue) && array[1][rowNum - 1].editable != 0) ? 1 : 0;
						}
					} else {
						editable = 1;
					}
					rowData[item.moduleDefineCode + '_' + rowNum] = {
						rowNum,
						editable,
					};
				});
			}

			const moduleDefine = tableColumns.find(column => column.moduleDefineName == '录入者') || {};
			const { moduleDefineCode } = moduleDefine;
			if (moduleDefineCode && !rowData[moduleDefineCode]) {
				rowData[moduleDefineCode] = {
					comment: "",
					criteriaDefineId,
					value: sessionStorage.userName,
					moduleDefineCode,
					rowNum,
				};
			}
			rowData["key"] = rowData.key;
			key++;
			rowData["isSave"] = false;
			return rowData;
		});
		this.setState({ count: key });
		this.reRenderScroll(typeName, data);
		return { data };
	}

	reRenderScroll = (typeName, data) => {
		// 处理表头分组没数据时，不显示滚动条的bug
		if (typeName == 'Type_Visit') {
			if (!data.length) {
				jquery('.type_Visit .ant-table-scroll .ant-table-header').css('margin-bottom', 0);
			} else {
				jquery('.type_Visit .ant-table-scroll .ant-table-header').css('margin-bottom', -16);
			}
		}
	}

	getFatherIndex = (record) => {
		const dataSource = this.state.dataSource;
		let dataIndex;
		dataSource.map((father, fatherIndex) => {
			if (father['children']) {
				father['children'].map((child, childIndex) => {
					if (child.key == record.key) {
						dataIndex = fatherIndex;
					}
				})
			}
		})
		return dataIndex;
	}

	onCellChange = (index, key, criteriaDefineId, special, record, tableColumn) => {
		return (value, type) => {
			if (type == 'reRender') {
				this.setState({ dataSource: [...this.state.dataSource] });
				return;
			}
			if (tableColumn.moduleDefineName == '访视分组') {
				const { currentGroup: { visitGroupingId } } = this.props;
				if (value != undefined && visitGroupingId != value) {
					this.setState({
						needTransfer: true,
						otherVisitGroupingId: value,
					}, () => {
						this.verify(record);
					})
				}
			}
			if (special && type !== "comment") {
				this.getVisitDate(value, key, index, criteriaDefineId, tableColumn, record);
			}
			const dataSource = [...this.state.dataSource];

			const { controllers, tableColumns, typeName } = this.props;
			
			if ((record && record.child) !== 1 || record.child == undefined) {
				if (!dataSource[index][key] || (dataSource[index][key] && !dataSource[index][key]['moduleDefineCode'])) {
					this.initValue(dataSource[index], key, tableColumn);
					if (type !== "comment") {
						if (value !== "") {
							dataSource[index][key]['value'] = value;
						}
					}
				}
				this.loopController(typeName, dataSource[index], key, value, tableColumns, controllers);
				dataSource[index][key][type] = value;
				dataSource[index]["isSave"] = true;
			} else {
				const dataIndex = this.getFatherIndex(record);
				if (dataSource[dataIndex] && dataSource[dataIndex]['children']) {
					if (!dataSource[dataIndex]['children'][index][key] || (dataSource[dataIndex]['children'][index][key] && !dataSource[dataIndex]['children'][index][key]['moduleDefineCode'])) {
						this.initValue(dataSource[dataIndex]['children'][index], key, tableColumn);
						if (type !== "comment") {
							if (value !== "") {
								dataSource[dataIndex]['children'][index][key]['value'] = value;
							}
						}
					}
				}
				this.loopController(typeName, dataSource[dataIndex]['children'][index], key, value, tableColumns, controllers);
				dataSource[dataIndex]['children'][index][key][type] = value;
				dataSource[dataIndex]['children'][index]["isSave"] = true;
			}
			this.setState({ dataSource });
		};
	}

	initValue = (obj, code, tableColumn) => {
		const { typeName } = this.props;
		obj[code] = {
			comment: "",
			criteriaDefineId: tableColumn.criteriaDefineId,
			editable: 1,
			moduleDefineCode: tableColumn.moduleDefineCode,
			rowNum: tableColumn.rowNum,
		};
		if (typeName != 'Type_Visit') {
			obj[code]['realRowNum'] = obj['rowNum'];
		}
	}

	loopController = (typeName, obj, key, value, tableColumns, controllers) => {
		if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
			const suffix = key.slice(-2);
			const code = key.slice(0, key.length - 2);
			// 查询是否是控制列表中
			controllers.forEach(item => {
				if (item.controller == code) {
					const controlledKey = item.controlled + suffix;
					if (item.oper == 'EQ') {
						//	被控制方存在
						if (obj[controlledKey] && obj[controlledKey].moduleDefineCode) {
							let editable;
							if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者编号') {
								editable = (!!value && obj[key]['editable'] != 0) ? 1 : 0;
							} else if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者状态') {
								editable = !!value ? 1 : 0;
							} else {
								editable = (item.value == value && obj[key]['editable'] != 0) ? 1 : 0;
							}
							obj[controlledKey]['editable'] = editable;
							if (!editable) {
								obj[controlledKey]['value'] = '';
							} else {
								if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者状态' && value && !obj[controlledKey].value) {
									obj[controlledKey].value = '试验进行中';
								}
								if (item.controllerName == '患者状态' && item.controlledName == '是否最后一个病例完成试验' && value == '完成整个研究') {
									obj[controlledKey]['value'] = '否';
								} else if (typeName == 'Type_Filter') {
									if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者编号') {
										const moduleDefine = tableColumns.find(column => column.moduleDefineName == '筛选编号') || {};
										const { moduleDefineCode } = moduleDefine;
										obj[controlledKey]['value'] = obj[moduleDefineCode + suffix]['value'];
									} else if (item.controllerName == '是否筛选成功' && (item.controlledName == '是否第一个受试者入组' || item.controlledName == '是否最后一个受试者入组')) {
										obj[controlledKey]['value'] = '否';
									}
								}
							}
						} else {
							// 不存在
							const controllColumn = tableColumns.find(column => column.moduleDefineCode == item.controlled) || {};
							this.initValue(obj, controlledKey, controllColumn);
							let editable;
							if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者编号') {
								editable = (!!value && obj[key]['editable'] != 0) ? 1 : 0;
							} else if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者状态') {
								editable = !!value ? 1 : 0;
							} else {
								editable = (item.value == value && obj[key]['editable'] != 0) ? 1 : 0;
							}
							obj[controlledKey]['editable'] = editable;
							if (!editable) {
								obj[controlledKey]['value'] = '';
							} else {
								if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者状态' && value && !obj[controlledKey].value) {
									obj[controlledKey].value = '试验进行中';
								}
								if (item.controllerName == '患者状态' && item.controlledName == '是否最后一个病例完成试验' && value == '完成整个研究') {
									obj[controlledKey]['value'] = '否';
								} else if (typeName == 'Type_Filter') {
									if (item.controllerName == '随机(入组)时间' && item.controlledName == '患者编号') {
										const moduleDefine = tableColumns.find(column => column.moduleDefineName == '筛选编号') || {};
										const { moduleDefineCode } = moduleDefine;
										obj[controlledKey]['value'] = obj[moduleDefineCode + suffix]['value'];
									} else if (item.controllerName == '是否筛选成功' && (item.controlledName == '是否第一个受试者入组' || item.controlledName == '是否最后一个受试者入组')) {
										obj[controlledKey]['value'] = '否';
									}
								}
							}
						}
					}
					// 查询被控制方是否在控制列表中作为控制方存在
					const newValue = obj[controlledKey]['value'] || '';
					this.loopController(typeName, obj, controlledKey, newValue, tableColumns, controllers);
				}
			});
		}
	}

	onPatientCodeChange = (index, key, criteriaDefineId, record) => {
		return (value, type) => {
			const { dataSource } = this.state;
			const { controllers, tableColumns, typeName } = this.props;
			if (record && record.child !== 1) {
				const rowObj = dataSource[index];
				if (rowObj.key && rowObj.key.endsWith("new5efk")) {
					if (value.patientId) {
						rowObj.patientUserId = value.patientId;
					}
				}
				rowObj.newPatientUserId = value.patientId;
				Object.keys(value).forEach(item => {
					tableColumns.forEach(column => {
						if (column.moduleDefineCode == item) {
							const currentCode = `${item}_${rowObj.rowNum || 1}`;
							if (rowObj[currentCode]) {
								// const hasValue = !!rowObj[currentCode].value;
								rowObj[currentCode] = {
									...rowObj[currentCode],
									value: value[item],
									moduleDefineCode: item,
									criteriaDefineId: column.criteriaDefineId,
								};
								this.loopController(typeName, rowObj, currentCode, value[item], tableColumns, controllers);
							} else {
								rowObj[currentCode] = {
									comment: "",
									criteriaDefineId: column.criteriaDefineId,
									value: value[item],
									moduleDefineCode: item,
									rowNum: rowObj.rowNum,
								};
								this.loopController(typeName, rowObj, currentCode, value[item], tableColumns, controllers);
							}
						}
					});
				});
			} else {
				const dataIndex = this.getFatherIndex(record);
				if (rowObj.key && rowObj.key.endsWith("new5efk")) {
					if (value.patientId) {
						dataSource[dataIndex]['children'][index].patientUserId = value.patientId;
					}
				}
				dataSource[dataIndex]['children'][index].newPatientUserId = dataSource[dataIndex]['children'][index].patientUserId;
			}
			this.setState({ dataSource });
		};
	}

	handleAdd = () => {
        this.handleAddRecord();
	}

	handleAddRecord = () => {
		const { controllers, typeName } = this.props;
		const { count, dataSource, moduleDefineCode, criteriaDefineId, tableColumns } = this.state;
		const newData = {
			key: count + "new5efk",
			patientUserId: -1,
			isSave: true,
			[moduleDefineCode + '_1']: {
				comment: "",
				criteriaDefineId,
				value: sessionStorage.userName,
				moduleDefineCode,
				rowNum: 1,
			},
			editable: 1
		};
		if (typeName == 'Type_Pre_Filter' || typeName == 'Type_Filter' || typeName == 'Type_Visit') {
			tableColumns.forEach(item => {
				if (item.moduleDefineCode != moduleDefineCode) {
					const isControlled = controllers.some(controll => controll.controlled == item.moduleDefineCode);
					newData[item.moduleDefineCode + '_1'] = {
						rowNum: 1,
						editable: isControlled ? 0 : 1,
					};
				}
			});
		}
		
		this.setState({
			dataSource: [newData, ...dataSource],
			count: count + 1,
		}, () => {
			const { tableColumns } = this.state;
			const { columns } = this.convertColumns(tableColumns);
			this.setState({ columns });
		});
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ dataSource: [], columns: [], count: 0 }, () => {
			const { tableColumns, tableDatas, loading, hasChild } = nextProps;
			this.setState({
				dataSource: this.convertDataSource(tableDatas, tableColumns).data,
				tableColumns,
				loading,
				hasChild,
			}, () => {
				const { columns } = this.convertColumns(tableColumns);
				this.setState({ columns })
			});
		});
		 
	}

	componentDidMount () {
		const { tableColumns, tableDatas, loading, hasChild } = this.props;
		this.setState({
			dataSource: this.convertDataSource(tableDatas, tableColumns).data,
			tableColumns,
			loading,
			hasChild,
		}, () => {
			const { columns } = this.convertColumns(tableColumns);
			this.setState({ columns })
		});
		this.queryInvStatus();
		 
	}
	
	 queryInvStatus = () => {
        const { invId } = sessionStorage;
        AjaxRequest.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryInvStatus,
			async:false,
            data: {
                investigationId: invId,
                publishStatus: this.published ? 'UNPUBLISHED' : 'PUBLISHED',
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({  isFilterProcess: res.isFilterProcess });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }

	render() {
		const { dataSource,  columns, scrollX, loading } = this.state;
		dataSource.forEach((item,index)=>item.index = index + 1);
		return (
			<div>
				{/* <Table
					bordered
					dataSource={dataSource}
					pagination={false}
					columns={columns}
					loading={loading}
					scroll={{ x: scrollX, y: 500 }}
					className='table-cell-row crf-table'
					rowKey={record => record.index}
				/> */}
				 <TableC
					data={dataSource}
					scrollY={500}
					loading={loading}
					columns={columns}
					rowKey="index"
					className="historyRecord"
					pagination={false}
					onChange={this.handleTableChange}
				/>
			</div>
		);
	}
}

class Crf extends Component {
    state = {
        loading: false,
        controllers: [],
        tableColumns: [],
        tableDatas: [],
        hasChild: 0,
        disableValue: true,
		patientUserId: '',
		panes: [],
        activeKey: '',
	}

	handleTabChange = (activeKey) => {
        this.setState({ activeKey }, () => {
            this.loadData();
        });
	}

	queryPlan = () => {
        this.setState({ loading: true });
        const options = {
            url: API_URL.plan.queryVisitGrouping,
            data: { publishStatus: 'ALL' },
            dataType: 'json',
            doneResult: res => {
				const { data } = res;
                const [{ visitGroupingId } = {}] = data || [];
                const activeKey = visitGroupingId ? String(visitGroupingId) : undefined;

                this.setState({
                    activeKey,
                    loading: false,
                    panes: data || [],
                }, () => {
                    this.loadData();
                });
            },
        };
        AjaxRequest.sendRequest(options);
    }
	
	queryInvStatus = () => {
        const { invId } = sessionStorage;
        AjaxRequest.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryInvStatus,
			async:false,
            data: {
                investigationId: invId,
                publishStatus: this.published ? 'UNPUBLISHED' : 'PUBLISHED',
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({  isFilterProcess: res.isFilterProcess });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }
	
    loadData = () => {
        let { patientUserId, activeKey ,isFilterProcess} = this.state;
        const { typeName } = this.props;
        this.setState({ loading: true });
		
        const options = {
            url: API_URL.execute.list,
            data: {
                typeName,
                offset: 1,
                limit: 15,
                patientUserId,
				visitGroupingId: activeKey,
				isPreview:1,
            },
            dataType: 'json',
            doneResult: ( data => {
                const { datas = [], hasChild } = data.data || {};
                const { controllers = [], tableColumns = [] } = data.data.tree.data || {};
                if(tableColumns[0]){
                    tableColumns[0]["fixed"] = "left";
                }
                const opcolumn = {
                    moduleDefineCode: 'op',
                    moduleDefineName: '操作',
					criteriaDataType: 'TEXT',
					
                };
                if (tableColumns.length > 0) {
                    tableColumns.unshift(opcolumn);
                }
                let disableValue = false;
                if(data.addable == 0){
                    disableValue = true;
                }

                this.setState({
                    controllers,
                    tableColumns,
                    tableDatas: datas,
                    hasChild,
                    loading: false,
                    disableValue,
                    patientUserId: '',
                }, () => {
					if ((isFilterProcess == 1 && typeName === 'Type_Filter')||(isFilterProcess == 0 && typeName === 'Type_Visit')) {
						!datas.length && this.handleAdd();
					}
				});
            }),
            errorResult: (() => {
                this.setState({ loading: false });
            })
        };
        AjaxRequest.sendRequest(options);
    }

    handleAdd = () => {
        this.crfTableRef.handleAdd();
    }

    componentWillMount() {
        this.queryPlan();
		this.queryInvStatus();
    }
	
	loadRefData = () => {
		const { typeName } = this.props;
		this.props.loadRefData(typeName);
	}

	getContent = (pane) => {
        const { typeName } = this.props;
        const { loading, tableColumns, tableDatas, controllers, hasChild, activeKey, panes } = this.state;
		if (pane.visitGroupingId == activeKey) {
            return (
				<CrfTable
					controllers={controllers}
					tableColumns={tableColumns}
					tableDatas={tableDatas}
					hasChild={hasChild}
					typeName={typeName}
					ref={el => this.crfTableRef = el}
					loading={loading}
					loadData={this.loadData}
					visitGroup={panes}
					currentGroup={pane}
					changeTabs={this.handleTabChange}
					loadRefData={this.loadRefData}
				/>
            );
        } else {
            return null;
        }
    }

    render() {
		const { typeName } = this.props;
        const { activeKey, panes, isFilterProcess } = this.state;
        return (
            <div className="main execute-crf">
				{
					(typeName === 'Type_Visit' && panes.length > 1) ?
						<Tabs
							onChange={this.handleTabChange}
							activeKey={activeKey}
							type="card"
						>
							{
								panes.map(pane => (
									<TabPane
										forceRender={true}
										key={pane.visitGroupingId}
										tab={<div className="execute-crf-tab">{pane.visitGroupingName}</div>}
									>
										{this.getContent(pane)}
									</TabPane>
								))
							}
						</Tabs>
					:
						this.getContent(panes.length ? panes[0] : {})
				}
            </div>
        );
    }
}

export default Crf;



// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/components/CrfPeriod.js